import { useEffect, useRef } from "react";
import { useWindowSize } from "./utils";

function FrameOverlay() {
  const canvasRef = useRef();
  const bottomRef = useRef();
  const topRef = useRef();
  const { width, height } = useWindowSize();

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = 2000;
    canvas.height = 2000;
    const ctx = canvas.getContext("2d");

    ctx.globalAlpha = 1;
    ctx.fillStyle = "#FFFF";
    ctx.rect(0, 0, 2000, 2000);
    ctx.stroke();
    ctx.fill();

    ctx.save();
    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    if (
      navigator.userAgent.includes("Firefox") ||
      navigator.userAgent.includes("Safari")
    ) {
      ctx.rect(30, 10, 1940, 1830);
    } else {
      ctx.roundRect(30, 10, 1940, 1830, [14]);
    }
    ctx.fill();
    ctx.restore();

    // BOTTOM PART
    const bottomCanvas = bottomRef.current;
    const bottomctx = bottomCanvas.getContext("2d");
    bottomCanvas.width = 2000;
    bottomCanvas.height = 2000;
    bottomctx.globalAlpha = 1;
    bottomctx.fillStyle = "#FFFF";
    bottomctx.rect(0, 0, 2000, 2000);
    bottomctx.stroke();
    bottomctx.fill();

    // TOP PART
    const topCanvas = topRef.current;
    const topctx = topCanvas.getContext("2d");
    topCanvas.width = 2000;
    topCanvas.height = 2000;
    topctx.globalAlpha = 1;
    topctx.fillStyle = "#FFFF";
    topctx.rect(0, 0, 2000, 2000);
    topctx.stroke();
    topctx.fill();
  }, [width, height]);

  return (
    <>
      <canvas
        id="topCanvas"
        ref={topRef}
        style={{
          position: "fixed",
          top: 45,
          width: window.innerWidth,
          height: "13px",
          zIndex: 1000,
        }}
      />
      <canvas
        id="canvas"
        ref={canvasRef}
        style={{
          position: "fixed",
          width: window.innerWidth,
          height: window.innerHeight,
          zIndex: 1,
        }}
      />
      <canvas
        id="bottomCanvas"
        ref={bottomRef}
        style={{
          position: "fixed",
          bottom: 0,
          width: window.innerWidth,
          height: "14px",
          zIndex: 1000,
        }}
      />
    </>
  );
}

export default FrameOverlay;
